import _ from 'underscore'
import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import historyFullStore from './club-history/club-history-full/club-history-full-store';
import historySingleStore from './club-history/club-history-single/club-history-single-store';
import clubTeamListStore from './club-team-list/club-team-list-store';
import clubModel from './club-model';
import clubPager from './club-pager';
import service from './club-service';
import teamService from '../team/team-service';
import userService from '../../user/user-service';
import managerService from '../manager/manager-service';
/* eslint-disable */ 

export default {
  namespaced: true,

  modules: {
    "historyFull": historyFullStore,
    "historySingle": historySingleStore,
    "clubTeamList": clubTeamListStore
  },

  state: {
    loading: false,
    list: [],
    pager: clubPager.build(),
    model: clubModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.clubEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.clubEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.clubViewer.id,
        roles.clubEditor.id,
        roles.clubManager.id
      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.clubEditor.id
      ]);
    },
    isClubManager: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.clubManager.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || clubModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = clubPager.build();
      state.model = clubModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      })
    },

    new({ commit }) {
      commit('MODEL', null);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      })
    },

    save({ getters, commit, rootGetters, dispatch }, club) {
      commit('LOADING', true);
      // eslint-disable-next-line 
      var modelToSave = getters.model

      if (club !== null ) {
        modelToSave = club
      } 

      return service
        .save(modelToSave, rootGetters['auth/user'])
        .then((modelSaved) => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.club.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
          return Promise.resolve(modelSaved);
        })
    },

    createManagerSendEmail({ commit, rootGetters, dispatch }, data) {
      commit('LOADING', true);
       // eslint-disable-next-line
       console.log("<---- CREATE MANAGER AND SEND EMAIL");
       
      console.log(data);
      console.log( _.isArray(data.teams));
      // Si no hay equipos no se puede enviar la invitacion
      if (!_.isObject(data.teams)) {
        commit('LOADING', false);
        var error = new Error('Debe haber al menos un equipo en el club para enviar la invitación.')
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      } else {
        return userService
        .createUserManagerSendEmail(data, rootGetters['auth/user'])
        .then((model) => {
          
      
          dispatch(
            'shared/success',
            `${i18n.t('notification.invitationHasSendSuccessfully')}`,
            { root: true }
          );

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
      }
    },

    destroy({ commit, dispatch, rootGetters }, club) {
      commit('LOADING', true);

      return service
        .destroy(club, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.club.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .then(() => dispatch('list'))
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch, rootGetters}) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
      
    },

    listClubManager({ commit, dispatch, rootGetters}) {

      var user = rootGetters['auth/user']
      var clubs = _.map(user.clubs, (value, key, list)=> {
        return value
      })
      console.log("<--- LIST CLUB MANAGER");
      console.log(clubs);
      
      commit('LIST', clubs);
      return Promise.resolve()
    },


    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      teamService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'teams', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      managerService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'managers', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/club/club-store.js